// extracted by mini-css-extract-plugin
export var cardSelected = "_jv-2";
export var image = "_jv-1";
export var table = "_jv-0";